export const RICH_TEXT = 'waitrosegroceriescms/components/content/richtext';
export const NAVIGATION_LINK = 'waitrosegroceriescms/components/content/navigation/navigationlinks';
export const PAGE_TITLE = 'waitrosegroceriescms/components/content/title';
export const CONTAINER = 'waitrosegroceriescms/components/content/container';
export const RESPONSIVE_GRID = 'waitrosegroceriescms/components/structure/responsivegrid';
export const EXPERIENCE_FRAGMENT_REFERENCE =
  'waitrosegroceriescms/components/content/experiencefragmentreference';
export const IMAGE = 'waitrosegroceriescms/components/content/image';
